import { default as VpAuth } from '@vp/auth';
import init from './init';
import useIdentity from './hooks/useIdentity';
var VistaprintAuth = {
    WebAuth: VpAuth.WebAuth,
    init: init
};
export { VistaprintAuth, useIdentity };
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiaW5kZXguanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi9zcmMvaW5kZXgudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUEsT0FBTyxFQUFDLE9BQU8sSUFBSSxNQUFNLEVBQUMsTUFBTSxVQUFVLENBQUM7QUFDM0MsT0FBTyxJQUFJLE1BQU0sUUFBUSxDQUFDO0FBQzFCLE9BQU8sV0FBVyxNQUFNLHFCQUFxQixDQUFDO0FBTzlDLElBQU0sY0FBYyxHQUFTO0lBQ3pCLE9BQU8sRUFBRSxNQUFNLENBQUMsT0FBTztJQUN2QixJQUFJLEVBQUUsSUFBSTtDQUNiLENBQUM7QUFFRixPQUFPLEVBQUUsY0FBYyxFQUFFLFdBQVcsRUFBRSxDQUFDIn0=